module.exports = __webpack_public_path__ + "img/icon335.ae09696d.png";